import React from "react";
import { Landmark, HeartHandshake, Home } from "lucide-react";

const cards = [
  {
    icon: Landmark,
    title: "Nil-Rate Band (NRB)",
    bg: "bg-secondary",
    body: "Everyone gets a £325,000 tax-free allowance called the Nil-Rate Band. Anything in your estate below this figure passes on with no Inheritance Tax at all. Only the value above your combined allowances is taxed (usually at 40%).",
  },
  {
    icon: HeartHandshake,
    title: "Spouse / civil partner transfer",
    bg: "bg-primary",
    body: "When one spouse or civil partner dies, anything left to the other is tax-free — and any unused allowance transfers across. If the first to die used none of their NRB, the survivor can have up to £650,000 (two full £325,000 bands). That's what the 'unused allowance from late spouse' options set — 50% or 100%.",
  },
  {
    icon: Home,
    title: "Residence Nil-Rate Band (RNRB)",
    bg: "bg-accent",
    body: "An extra allowance of up to £175,000 applies when your main home passes to direct descendants (children, grandchildren, etc.). It's also transferable between spouses, so a couple can shield up to £350,000 of home value. It's capped at the home's value and tapers away by £1 for every £2 your estate exceeds £2,000,000 — disappearing entirely for very large estates.",
  },
];

export const Explainer = () => (
  <section data-testid="allowances-explainer" className="mt-14">
    <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-2">
      Understanding the allowances
    </h2>
    <p className="text-base font-medium text-foreground/80 mb-6 max-w-2xl">
      These are the tax-free bands that decide whether your estate owes anything. Here's what each
      one means in plain English.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {cards.map((c) => (
        <div
          key={c.title}
          data-testid={`explainer-${c.title.split(" ")[0].toLowerCase()}`}
          className="rounded-2xl border-2 border-foreground bg-white p-6 brutal-shadow-sm hover:-translate-y-1 hover:-translate-x-1 hover:shadow-[8px_8px_0px_#1e2b24] transition-[transform,box-shadow] duration-200"
        >
          <span className={`grid place-items-center w-11 h-11 rounded-xl border-2 border-foreground ${c.bg} mb-4`}>
            <c.icon size={20} strokeWidth={2.5} />
          </span>
          <h3 className="text-lg font-bold mb-2">{c.title}</h3>
          <p className="text-sm font-medium leading-relaxed text-foreground/80">{c.body}</p>
        </div>
      ))}
    </div>
  </section>
);
